<template>
    <div class="flex flex-row">
        <span class="mr-2">
            {{ label }}
        </span>

        <span
            aria-checked="false"
            class="bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
            :class="{
                'bg-blue-600': value,
                'bg-gray-200': !value
            }"
            role="checkbox"
            tabindex="0"
            @click="onClick"
        >
            <span
                aria-hidden="true"
                class="translate-x-0 inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
                :class="{
                    'translate-x-5': value,
                    'translate-x-0': !value
                }"
            />
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true,
            },
            value: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            onClick() {
                this.$emit('input', !this.value);
            },
        },
    };
</script>
